/* eslint-disable @typescript-eslint/no-explicit-any */
/**
 * @desc 文件List压缩成zip后上传
 */
import { defaultSuccess, defaultError, http } from "@/plugins/axios";

export default async function (
  success: ({
    data,
    ext,
    state,
    errors,
  }: {
    data: string;
    ext: ObjectMap;
    state: "SUCCESS" | "FAIL" | "EXCEPTION";
    errors?: Array<string>;
  }) => void = defaultSuccess,
  fail: (error: string) => void = defaultError
): Promise<void> {
  return http({
    method: "post",
    url: `/oss/filesZip`,
  })
    .then((data) => success(data as any))
    .catch((error) => fail(error));
}
